<div class="flex-grow-1 d-flex flex-column mx-3 mt-3 p-2 player-info-border">
  <div class="fled-grow-1 d-flex flex-row">
    <div class="mr-3">
      <app-initials-circle [name]="player.name"></app-initials-circle>
    </div>
    <div class="d-flex flex-column flex-grow-1 player-info-panel">
      <div class="d-flex flex-grow-1 flex-row font-weight-bold">
        <div class="flex-grow-1">{{player.name}}</div>
        <div class="flex-grow-1 text-right">
          <app-court-event-status-pill [status]="player.status">
          </app-court-event-status-pill>
        </div>
      </div>
      <div class="flex-grow-1 mt-1"><app-member-status-badge [memberStatusLabel]="player.memberStatusLabel"></app-member-status-badge></div>
      <div class="flex-grow-1">ID: {{player.memberId}}</div>
      <div class="flex-grow-1" *ngIf="player.membershipTypeDescription">Type: {{player.membershipTypeDescription}}</div>
      <div class="flex-grow-1">{{player.phoneNumber | phoneMask}}&nbsp;</div>
      <div class="flex-grow-1">{{player.email}}&nbsp;</div>
    </div>
  </div>
  <div class="flex-grow-1 mb-3 mt-3">
    <app-player-info-status [player]="player" [courtBooking]="courtBooking" [club]="club" (playerChanged)="onPlayerChanged()"></app-player-info-status>
  </div>
</div>
